<template>
    <div class="single-sales-chart-wrapper" :class="[$mq]">
        <div class="single-sales-chart">
            <div class="top-chart">
                <div class="title">{{ title }}</div>
            </div>
            <div class="chart-container">
                <apexchart :ref="'chart'" width="99%" type="line" :height="height" :options="chartOptions" :series="series"></apexchart>
            </div>
        </div>
    </div>
</template>

<script>
import i18n from '@/i18n'
import { formatCurrency } from "@/utils/formatters";

export default {
    name: 'ChartSales',
    props: {
        data: {
            type: Object,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        height: {
            type: Number,
            default: 200
        },
        showLegend: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
        }
    },
    computed: {
        chartOptions() {
            return {
                chart: {
                    animations: {
                        enabled: false
                    },
                    toolbar: {
                        show: false
                    },
                    background: '#fff',
                    zoom: {
                        enabled: false
                    },
                    selection: {
                        enabled: false
                    }
                },
                grid: {
                    show: false,
                    padding: {
                        left: 0,
                        right: 0
                    }
                },
                tooltip: {
                    x: {
                        show: true
                    },
                    y: {
                        formatter: function (value) {
                            if (value === null || value === undefined || isNaN(Number(value))) {
                                return ''
                            }
                            return formatCurrency(value, 0)
                        }
                    }
                },

                xaxis: {
                    categories: this.xAxisValues,
                    hideOverlappingLabels: true,
                    stepSize: 5,
                    tickAmount: (this.$mq == 'portrait' ? this.xAxisValues.length / 2 : this.xAxisValues.length),
                    labels: {
                        hideOverlappingLabels: true,
                        trim: true,
                    }

                    //range: 24,    
                    
                },
                yaxis: {
                    min: 0,
                    hideOverlappingLabels: true,
                    tickAmount: 4,
                    forceNiceScale: true,
                    decimalsInFloat: false,
                },
                //nodata
                noData: {
                    text: i18n.t('sales.chart.no_data'),
                    align: 'center',
                    verticalAlign: 'middle',
                    offsetX: 0,
                    offsetY: 0,
                    style: {
                        color: '#000',
                        fontSize: '14px',
                        fontFamily: 'Avenir-Regular'
                    }
                },
                legend: {
                    show: this.showLegend
                },
                stroke: {
                    curve: 'smooth',
                    width: 3
                },
                datalabels: {
                    enabled: true,
                    enabledOnSeries: [0],
                    formatter: function (value) {
                        if (value === null || value === undefined || isNaN(Number(value))) {
                            return ''
                        }
                        return Number(value).toFixed(1)
                    },
                    style: {
                        colors: ['#000']
                    },
                    background: {
                        enabled: true,
                        foreColor: '#fff',
                        padding: 2,
                        borderRadius: 2,
                        borderWidth: 1,
                        borderColor: '#fff',
                        opacity: 0.9
                    }
                }
            }
        },
        series() {
            const forecastData = (this.data && this.data.forecast && typeof this.data.forecast === 'object') 
                ? Object.values(this.data.forecast) 
                : []
            const actualData = (this.data && this.data.actual && typeof this.data.actual === 'object') 
                ? Object.values(this.data.actual) 
                : []
            
            return [
                {
                    name: this.$t('sales.table.header.forecast'),
                    data: forecastData
                },
                {
                    name: this.$t('sales.table.header.actual'),
                    data: actualData
                }
            ]
        },
        xAxisValues() {
            if (this.data && this.data.forecast && typeof this.data.forecast === 'object') {
                return Object.keys(this.data.forecast).map(key => moment(key).format('HH:mm'))
            }
            return []
        }
    },
    methods: {
    },
    mounted() {
    }
}
</script>

<style lang="scss" scoped>
.single-sales-chart-wrapper {
    width: 100%;

    .single-sales-chart {
    width: 100%;
    height: auto;
    box-shadow: 0px 0px 5px #e3e7ed;
    background-color: $color-white;
    border-radius: 4px;

    .top-chart {
        @include display-flex();
        @include align-items(center);
        padding: 8px;
        height: 50px;

        .title {
            font-family: $text-bold;
            @include font-size(sm);
        }
    }
    .chart-container {
        width: 100%;
        height: 100%;
        background-color: #fff;

        &.nodata {
            @include display-flex();
            @include align-items(center);
            @include justify-content(center);
        }
        .greybox {
            height: 250px;
            @include background($image: img('loader_dark.svg'), $position: center center, $size: 50px, $color: #fff);
        }
    }

    }

    &.portrait {
        .single-sales-chart {
            .top-chart {
                .title {
                    @include font-size(xs);
                }
            }
        }
    }
}
</style>